define('commons/xor-form',['jquery'], 
        function($) {

    var XorForm = function(container, options) {
        var here = this;
        var selectedField = null;
        this.fields = [];

        // Setting the configuration
        this.settings = $.extend({
            radioName: ''
        }, options);

        this.radioButtons = $(container).find('input[name=' + this.settings.radioName + ']');
        this.radioButtons.each($.proxy(function(index, radioButton) {
            var fieldId = this._getIdFromRadioButton(radioButton)
            this.fields.push(fieldId);
            //select first field with a non empty value
            if (selectedField == null && $(fieldId).val().trim() !== '') {
                selectedField = fieldId;
            }
            $(fieldId + "-area").click(function() {
                here._fieldSelected(here._getIdFromClickableArea(this));
            });
            $(radioButton).click(function() {
                here._fieldSelected(here._getIdFromRadioButton(this));
            });
        }, this));
        if (selectedField != null) {
            this._fieldSelected(selectedField);
        } else if (this.fields.length > 0) {
            //select first field if all fields are empty
            this._fieldSelected(this.fields[0]);
        }
    };

    XorForm.prototype._getIdFromRadioButton = function(radioButton) {
        return "#" + radioButton.id.replace("-radio", "");
    };

    XorForm.prototype._getIdFromClickableArea = function(clickableArea) {
        return "#" + clickableArea.id.replace("-area", "");
    };

    XorForm.prototype._fieldSelected = function(selectedField) {
        this.fields.forEach(function(field){
            $(field).prop('disabled', true);
        });
        $(selectedField).prop('disabled', false).focus();
        $(selectedField + "-radio").prop('checked', true);
    };

    return XorForm;
});

